export const RECARGAS_PLAN_ID = "recargas";

export const RECARGAS_PURCHASE_REFUSAL =
  "Los créditos no se compran como un plan: actívalos desde Plan y facturación y recarga tu saldo.";

export const RECARGAS_EXTRA_AGENT_REFUSAL =
  "Pagando con créditos no se pueden comprar agentes adicionales. Para tener más agentes elige un plan mensual.";

export const RECARGAS_ETB_REFUSAL = "El pago con créditos no está disponible para cuentas ETB.";

export const RECARGAS_NO_CHARGE_SQLSTATE = "RCG02";

export const RECARGAS_NO_CHARGE_REFUSAL =
  "El pago con créditos no está disponible para cuentas sin cobro: cobra cada conversación del saldo de créditos. Quita la marca de cuenta sin cobro antes de asignarlo.";

export interface ZeroQuotaCapInput {
  plan?: string | null;
  free_quota_withheld?: boolean | null;
}

export function isRecargasPlan(plan: string | null | undefined): boolean {
  return plan === RECARGAS_PLAN_ID;
}

export function zeroQuotaIsCap(quota: ZeroQuotaCapInput | null | undefined): boolean {
  return quota?.free_quota_withheld === true || isRecargasPlan(quota?.plan);
}

export const RECARGAS_AGENT_LIMIT_SQLSTATE = "RCG01";

export const RECARGAS_AGENT_LIMIT_FALLBACK =
  "Pagando con créditos no puedes agregar más agentes. Tus agentes actuales siguen funcionando; para agregar uno nuevo elige un plan mensual.";

export interface AgentSeats {
  applies: boolean;
  limit: number | null;
  used: number | null;
  allowed: boolean;
  message: string | null;
}

export function parseAgentSeats(raw: unknown): AgentSeats | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const row = raw as Record<string, unknown>;
  if (typeof row.applies !== "boolean") return null;
  const num = (value: unknown) => (typeof value === "number" && Number.isFinite(value) ? value : null);
  return {
    applies: row.applies,
    limit: num(row.limit),
    used: num(row.used),
    allowed: row.allowed !== false,
    message: typeof row.message === "string" && row.message.trim() ? row.message : null,
  };
}

export function agentLimitMessage(error: { code?: string | null; message?: string | null } | null | undefined): string | null {
  if (error?.code !== RECARGAS_AGENT_LIMIT_SQLSTATE) return null;
  return error.message?.trim() || RECARGAS_AGENT_LIMIT_FALLBACK;
}

export async function agentSeatRefusal(
  // deno-lint-ignore no-explicit-any
  sb: any,
  orgId: string,
): Promise<string | null> {
  try {
    const { data, error } = await sb.rpc("credit_plan_agent_seats", { p_org: orgId });
    if (error) {
      console.error(`[credits-plan] agent seats of ${orgId} unreadable:`, String(error.message ?? ""));
      return null;
    }
    const seats = parseAgentSeats(data);
    return seats && !seats.allowed ? seats.message ?? RECARGAS_AGENT_LIMIT_FALLBACK : null;
  } catch (err) {
    console.error(`[credits-plan] agent seats of ${orgId} unreadable:`, err instanceof Error ? err.message : String(err));
    return null;
  }
}
